export default __webpack_public_path__ + "static/media/product13.66345216.webp";